export default function IosPartlysunny() {
  return (
    <div
      className="ion-icon-ios-partlysunny"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
<![CDATA[
	.st0{fill:#010101;}
]]>
</style>
<g>
	<g>
		<g>
			<rect x="208" y="96" class="st0" width="16" height="54"/>
			<rect x="64" y="240" class="st0" width="55" height="16"/>
			<polygon class="st0" points="107.5,149.1 118.5,138 149.9,169.6 138.9,180.7 			"/>
			<polygon class="st0" points="287.4,179.7 276.4,168.6 307.7,137 318.8,148.1 			"/>
			<polygon class="st0" points="120.5,352.5 109.5,341.4 140.9,309.8 151.9,320.9 			"/>
		</g>
		<path class="st0" d="M299,224c-43.3,0-78.3,35.2-78.3,78.5c0,2.6,0.1,5.2,0.4,7.8c-26.4,2.3-47.1,25.5-47.1,52.6
			c0,28.6,23.2,53.1,51.7,53.1h157.7c35.7,0,64.6-29.9,64.6-65.7c0-35.8-28.9-65.3-64.6-65.3c-2.7,0-5.4,0-8,0.3
			C367.5,250.3,336.3,224,299,224L299,224z"/>
	</g>
	<path class="st0" d="M264.7,196.3c-12.9-14.3-31.4-23.3-52-23.3c-38.7,0-70.3,31.7-70.3,70.7c0,27.4,15.6,51.2,38.3,62.9
		c0,0,0-0.1,0-0.1c0,0,0.1,0.1,0.1,0.1c4.5-12.1,11.4-19.8,22.6-25.6c0.2-0.1,0.4-0.2,0.7-0.4c0.2-0.1,0.5-0.2,0.7-0.3
		c-0.2-2.3-0.3-4.7-0.3-7c-0.3-31.9,30.2-70.5,61-75.4c0.1-0.1,0.3-0.1,0.4-0.2C265.5,197.3,265.1,196.8,264.7,196.3z"/>
</g>
</svg>
`,
      }}
    />
  )
}
